// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"1b968ec7","132":"f66a5978","231":"4c52e2a2","323":"df41e388","453":"6fe1ece5","864":"b29577e3"}[chunkId] + ".chunk.js";
};